import { Skeleton } from '@finn/design-system/atoms/skeleton';
import { ProductImage } from '@finn/ua-vehicle';
import { getCloudinaryImgUrl, parseToHtml, trackEvent } from '@finn/ui-utils';
import Link from 'next/link';

import { ArticleData } from './meta';

type Props = {
  article: ArticleData;
};

export const ArticleCard = ({ article }: Props) => {
  const cloudinaryImgUrl = getCloudinaryImgUrl(article.imageURL ?? '', {
    dpr: 2,
    ar: '16:9',
    c: 'fill',
  });

  const articleLink =
    article?.link?.startsWith('/') || article?.link?.startsWith('http')
      ? article?.link
      : `/${article?.link}`;

  return (
    <Link
      key={article.slug}
      href={articleLink}
      className="flex h-full flex-col"
      onClick={() => {
        trackEvent('Article Card Clicked', {
          articleLink,
          articleTitle: parseToHtml(article.title),
        });
      }}
    >
      <div className="flex-1 overflow-hidden">
        {cloudinaryImgUrl ? (
          <div className="relative rounded bg-snow">
            <ProductImage
              vehiclePictureURL={article.imageURL}
              shouldPreload
              shouldShowPlaceholder
              altText={article.imageAlt}
              imageClassName="max-w-full"
              className="top-0 sm:min-h-full"
            />
          </div>
        ) : (
          <Skeleton className="size-full" />
        )}
      </div>
      <div className="mt-4 h-14">
        <div className="global-t5-semibold">{parseToHtml(article.title)}</div>
      </div>
    </Link>
  );
};
